import * as React from 'react';
import { CommerceToolsApi } from '@grandvisionhq/commercetools';
import { getBundleProductTitle } from '../../../utils/get-bundle-product-title.js';
import { isNewPrescriptionAndUpload } from '../../../utils/is-new-prescription-upload.js';
import ConfigurationSummaryRow from '../ConfigurationSummaryRow/ConfigurationSummaryRow.js';
import { FrameImage } from '../FrameImage/FrameImage.js';
import FrameInformationContainer from '../FrameInformation/FrameInformationContainer.js';
import PrescriptionSummaryContainer from '../PrescriptionSummary/PrescriptionSummaryContainer.js';
import { PrescriptionUploadSummaryContainer } from '../PrescriptionUploadSummary/PrescriptionUploadSummaryContainer.js';

const DesktopConfigurationSummary = ({ labels , bundlePrice , frame , addOn , lensType , lensPackage , isPhone , hasVisitedStepPrescription , hasVisitedStepLensPackage , hasVisitedStepAddOn , prescriptionType , totalPricePrefix , minimumBundleSupplement ,  })=>{
    return /*#__PURE__*/ React.createElement("div", {
        className: "desktop-configuration-summary"
    }, /*#__PURE__*/ React.createElement(FrameImage, null), frame && /*#__PURE__*/ React.createElement(ConfigurationSummaryRow, {
        className: "desktop-configuration-summary__frame-row",
        label: /*#__PURE__*/ React.createElement(FrameInformationContainer, {
            textHeadingVariant: "smallest",
            showImage: isPhone,
            textOrientation: "vertical"
        }),
        price: frame.price
    }), /*#__PURE__*/ React.createElement("div", {
        className: "desktop-configuration-summary__selections"
    }, lensType && /*#__PURE__*/ React.createElement(ConfigurationSummaryRow, {
        label: labels.lensType,
        value: getBundleProductTitle(lensType),
        price: lensType.price,
        discountText: lensType.discountText,
        step: "lensType",
        "data-t": "configuration-summary-row-lens-type"
    }), hasVisitedStepLensPackage && lensPackage && /*#__PURE__*/ React.createElement(ConfigurationSummaryRow, {
        label: labels.lensPackage,
        value: lensPackage.title,
        price: lensPackage.price,
        discountText: lensPackage.discountText,
        step: "lensPackage",
        "data-t": "configuration-summary-row-lens-package"
    }), hasVisitedStepAddOn && addOn && /*#__PURE__*/ React.createElement(ConfigurationSummaryRow, {
        label: labels.addOn,
        value: getBundleProductTitle(addOn),
        price: addOn.price,
        discountText: addOn.discountText,
        step: "lensAddOn",
        "data-t": "configuration-summary-row-add-on"
    }), minimumBundleSupplement && /*#__PURE__*/ React.createElement(ConfigurationSummaryRow, {
        label: labels.minimumBundleSupplement,
        price: minimumBundleSupplement,
        "data-t": "configuration-summary-row-minimum-supplement"
    }), /*#__PURE__*/ React.createElement(ConfigurationSummaryRow, {
        label: labels.totalPrice,
        price: bundlePrice,
        priceSize: "medium",
        pricePrefix: totalPricePrefix,
        "data-t": "configuration-summary-row-total-price"
    })), hasVisitedStepPrescription ? /*#__PURE__*/ React.createElement("div", {
        className: "desktop-configuration-summary__prescription"
    }, isNewPrescriptionAndUpload(prescriptionType) ? /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(PrescriptionSummaryContainer, null), /*#__PURE__*/ React.createElement(PrescriptionUploadSummaryContainer, {
        hideDividers: true,
        title: "products.glasses.configurator.footer.upload.title"
    })) : CommerceToolsApi.isPrescriptionFile(prescriptionType) ? /*#__PURE__*/ React.createElement(PrescriptionUploadSummaryContainer, {
        hideDividers: true
    }) : /*#__PURE__*/ React.createElement(PrescriptionSummaryContainer, null)) : null);
};

export { DesktopConfigurationSummary as default };
//# sourceMappingURL=DesktopConfigurationSummary.js.map
